import { makeStyles } from '@material-ui/core/styles'
import PageMetaData from '@v4/utils/data/PageMetaData'

const useStyles = makeStyles(
	theme => ({
		paper: {
			display: 'flex',
			flexDirection: 'column',
			padding: theme.spacing(1.8, 2.5, 2.5, 2.5),
			borderRadius: 0,
			height: '100%',
			[theme.breakpoints.up('sm')]: {
				flexDirection: 'row',
				padding: theme.spacing(4, 4.75, 4.75, 4.75),
			},
		},
		imageWrap: {
			[theme.breakpoints.down('xs')]: {
				width: '100%',
				display: 'flex',
				justifyContent: ({ mobileAlignment }) =>
					`${PageMetaData.CONTENT_ALIGNMENT[mobileAlignment]} !important`,
			},
		},
		image: {
			flexShrink: 0,
			width: theme.spacing(17),
			marginRight: theme.spacing(4.75),
			marginTop: theme.spacing(0.8),
			marginBottom: theme.spacing(3),

			'& img': {
				width: '100%',
			},
			[theme.breakpoints.down('xs')]: {
				marginRight: 0,
			},
		},
		buttonWrap: {
			justifyContent: 'start',

			[theme.breakpoints.down('xs')]: {
				justifyContent: ({ mobileAlignment }) =>
					`${PageMetaData.CONTENT_ALIGNMENT[mobileAlignment]} !important`,
			},
		},
		content: {
			alignItems: 'start',
		},
		text: {
			'& h3': {
				lineHeight: '1.3',
			},
		},
	}),
	{ name: 'CallToAction-Cta8' },
)

export default useStyles
